import { render, staticRenderFns } from "./TableAvenantArticlev2.vue?vue&type=template&id=ba2af2e4&"
import script from "./TableAvenantArticlev2.vue?vue&type=script&lang=js&"
export * from "./TableAvenantArticlev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports